var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoftVer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ff1414",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 46",
    id: "Layer_46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,6H6A3,3,0,0,0,3,9V44.87A3.08,3.08,0,0,0,6,48H25v4H23a3,3,0,0,0-3,3v3H44V55a3,3,0,0,0-3-3H39V48H58a3.08,3.08,0,0,0,3-3.13V9A3,3,0,0,0,58,6ZM5,9A1,1,0,0,1,6,8H58a1,1,0,0,1,1,1V35a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V9ZM41,54a1,1,0,0,1,1,1v1H22V55a1,1,0,0,1,1-1H41Zm-4-2H27V48H37Zm21-6H6a1.08,1.08,0,0,1-1-1.13v-7A3,3,0,0,0,6,38H58a3,3,0,0,0,1-.18v7A1.08,1.08,0,0,1,58,46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,34H54a3,3,0,0,0,3-3V13a3,3,0,0,0-3-3H10a3,3,0,0,0-3,3V31A3,3,0,0,0,10,34ZM9,13a1,1,0,0,1,1-1H54a1,1,0,0,1,1,1V31a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,19H47a1,1,0,0,0,0-2H17a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,23H47a1,1,0,0,0,0-2H17a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,27H47a1,1,0,0,0,0-2H17a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,40H30a2,2,0,0,0,0,4h4a2,2,0,0,0,0-4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftVer);
export default __webpack_public_path__ + "static/media/soft_ver.6e7298c8911f2e9178c5ae04c07c7724.svg";
export { ForwardRef as ReactComponent };